export default __webpack_public_path__ + "static/media/planet5.9768825b.png";